import css from './batchCreator.module.scss';

import { ComponentProps } from 'react';

import WordListItem from 'com/WordListItem';
import Button from 'core/ui/Button';
import { Textarea } from 'core/ui/Form';

export const TemplateTextarea: React.FC<
  Omit<ComponentProps<typeof Textarea>, 'onChange'> & {
    onChange(val: string): void;
  }
> = props => (
  <Textarea
    className={css.textareaInput}
    autoFocus
    placeholder={templatePlaceholder}
    {...props}
    onChange={evt => props.onChange(evt.target.value)}
  />
);

const templatePlaceholder = `
Put your cards here. They should be separated by an empty line. Each card contains two lines:
1st = the front side,
2nd = the back side.

For example (EN to DE):

I'm not a {dog}
Ich bin kei{n Hund}

She is my {sister}
Sie ist mein{e Schwester}
`.trim();

type TButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'link' | 'onClick'
> & { onClick: (evt: TAnyEvent) => void };

export const PreviewButton: React.FC<TButtonProps> = props => (
  <Button
    {...props}
    theme="primary"
    children="Preview"
    kkb="CmdOrCtrl+Enter"
    kkbCheckInControls
  />
);

export const EditButton: React.FC<TButtonProps> = props => (
  <Button {...props} children="Edit" kkb="Backspace" kkbCheckInControls />
);

export const SaveButton: React.FC<TButtonProps> = props => (
  <Button
    {...props}
    type="submit"
    children="Save"
    kkb="CmdOrCtrl+Enter"
    kkbCheckInControls
  />
);

export const CancelButton: React.FC<TButtonProps> = props => (
  <Button {...props} kkb="Escape" kkbCheckInControls>
    Cancel
  </Button>
);

export const CardsList = ({
  cards,
  deck,
}: {
  cards: TWordUpdate[];
  deck: TDeck;
}) => (
  <div className={css.wordList}>
    {cards.map((word, idx) => (
      <WordListItem
        key={`${idx}:${word.value}`}
        deck={deck}
        idx={idx}
        word={word}
      />
    ))}
  </div>
);
